<template>
    <v-form-group
            :label="label"
            :description="description"
            :error="error"
            :state="errorState">
        <div v-html="this.text"
             v-if="readonly"></div>
        <v-multiselect
                v-else
                v-model="input"
                tag-placeholder="Add this as new tag"
                placeholder="Search or add a tag"
                :options="[]"
                :multiple="true"
                :taggable="true"
                track-by="label"
                label="label"
                @tag="addTag"
                @remove="removeTag"
        />
    </v-form-group>
</template>

<script>
    import axios from 'axios'
    import field from '../../Mixins/field'
    import uniqid from 'uniqid'
    import _ from 'lodash'

    export default {
        mixins: [field],
        props: {
            value: {
                default() {
                    return []
                },
                type: Array
            }
        },
        computed: {
            text() {
                return this.value.reduce(function (text, tag) {
                    if (text) {
                        text += ', '
                    }
                    text += tag.label
                    return text
                }, '')
            }
        },
        methods: {
            addTag(label) {
                const tag = {
                    label
                }
                this.input.push(tag)
                this.handleInput(this.input)
            },

            removeTag(tag) {
                _.remove(this.input, function (item) {
                    return item.label === tag.label
                })
                this.handleInput(this.input)
            },

            handleInput(input) {
                this.$emit('input', input)
            }
        }
    }
</script>